import { StrictMode, Suspense, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { CanvasWrapper } from '@isaac_ua/drei-html-fix' // import CanvasWrapper

// import { Leva } from 'leva'
import './style.css'
import Experience from '/Experience.jsx'

const App = () => {
  const [zoomToggle, setzoomToggle] = useState(true);
  function zoomToggled() {
    setzoomToggle(x => !x);
    if (zoomToggle) { document.body.classList.remove('bgchange'); }
    else { document.body.classList.add('bgchange'); }

  }
  return (
    <Suspense fallback={<span className='loader'>loading...</span>}>
      <button type="button" onClick={() => zoomToggled()} className='button'>
        {zoomToggle ? "Zoom out" : "Zoom in"}
      </button>
      <CanvasWrapper
        canvasProps={{
          flat: true,
          linear: true,
          dpr: [1, 2],
          camera: {
            fov: 45,
            near: 0.1,
            far: 2000,
            position: [-0.38, -0.16, 1.32]
          }
        }}>
        <Experience zoomToggle={zoomToggle} />
      </CanvasWrapper>
      {/* <Leva collapsed /> */}
    </Suspense>
  );
};

createRoot(document.getElementById('root')).render(
  <App />
)
